import { addCarData, setChartDataOption, initOptionDemo } from '@/mapTools'

const state = {
  // 0开始 1初始化完成 2 option设置完成 -1 离开页面
  demo_chat_status: 0,
  demo_map_data_customer: [],
  demo_map_data_plant: [],
  demo_map_data_route: [],
  demo_map_data_center: []
}

const getters = {}

const actions = {
  setDemoChatStatus ({ commit }, data) {
    commit('changeDemoChatStatus', data)
  },
  initDemoMapOption ({ commit, dispatch }) {
    window.myDemoChat.clear()
    let dataP = {
      legendData: ['客户', '通力物流园', '乡镇卫生院'],
      row: []
    }
    window.myDemoChat.setOption(initOptionDemo(dataP), true)
    dispatch('setDemoChatStatus', 2)
  },
  setDemoMapDataCustomer ({ commit }, data) {
    commit('changeDemoMapDataCustomer', data)
  },
  setDemoMapDataPlant ({ commit }, data) {
    commit('changeDemoMapDataPlant', data)
  },
  setDemoMapDataCenter ({ commit }, data) {
    commit('changeDemoMapDataCenter', data)
  },
  setDemoMapDataRoute ({ commit }, data) {
    commit('changeDemoMapDataRoute', data)
  }
}

const mutations = {
  changeDemoChatStatus (state, data) {
    state.demo_chat_status = data
    if (data === 2) {
      let optionList = [{
        key: 'Location',
        data: state.demo_map_data_customer
      },
      {
        key: 'Plant',
        data: state.demo_map_data_plant
      },
      {
        key: 'centroids',
        data: state.demo_map_data_center
      }]
      optionList.forEach(function (item) {
        setChartDataOption(window.myDemoChat, item.key, item.data)
      })
      addCarData(window.myDemoChat, state.demo_map_data_route)
    }
  },
  changeDemoMapDataCustomer (state, data) {
    if (state.demo_chat_status === 2) {
      setChartDataOption(window.myDemoChat, 'Location', data)
    }
    state.demo_map_data_customer = data
  },
  changeDemoMapDataPlant (state, data) {
    if (state.demo_chat_status === 2) {
      setChartDataOption(window.myDemoChat, 'Plant', data)
    }
    state.demo_map_data_plant = data
  },
  changeDemoMapDataRoute (state, data) {
    if (state.demo_chat_status === 2) {
      addCarData(window.myDemoChat, data)
    }
    state.demo_map_data_route = data
  },
  changeDemoMapDataCenter (state, data) {
    if (state.demo_chat_status === 2) {
      console.log(data)
      setChartDataOption(window.myDemoChat, 'centroids', data)
    }
    state.demo_map_data_center = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/demo_map.js